<template>
  <Modal v-model="modifyPriceModal" :title="$t('key1006977')" :transfer="false" :mask-closable="false"
    width="1300" :styles="{top: '50px'}" @on-visible-change="modifyPriceModalChange">
    <Table
      :loading="tableLoading"
      border
      max-height="650"
      :columns="modifyPriceColumns"
      :data="modifyPriceData"
      :span-method="handleSpan">
    </Table>
    <template #footer>
      <Button @click="modifyPriceModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="modifyPriceBtn">{{ $t('key1000543') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {formatterNumber, getStoreGoodsData, getSpanMethod, batchAllWarehouseData, getAllCountrysData} from "@/utils/common";

export default {
  name: "modifyPriceModal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      modifyPriceModal: false,
      modifyPriceColumns: [],
      modifyPriceData: [],
      nationalSupplyPriceData: [],
    }
  },
  methods: {
    formatterNumber,
    // 获取修改价格列表数据
    getModifyPriceList(productId) {
      let v = this;
      v.handleColumns().then(() => {
        v.axios.get(api.get_productGoods_priceDetails + `?productId=${productId}`, {loading: true}).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            if (data.length > 0) {
              const newList = [];
              data.forEach(item => {
                const {productGoodsPrices, wmsInventoryList, ...vals} = item;
                const productGoodsPricesList = (productGoodsPrices || []);
                const wmsInventoriesList = (wmsInventoryList || []);
                // 组装国家供货价数据对象
                const productGoodsPricesObj = {};
                productGoodsPricesList.forEach(ele => {
                  const countryCode = ele.countryCode;
                  productGoodsPricesObj[`${countryCode}_productGoodsPriceId`] = ele.productGoodsPriceId;
                  productGoodsPricesObj[`${countryCode}_supplyPrice`] = ele.supplyPrice;
                });
                // 遍历库存数据列表合并
                wmsInventoriesList.forEach(ele => {
                  const obj = {
                    ...vals,
                    ...ele,
                    ...productGoodsPricesObj,
                    reportInventoryId: ele.inventoryId,
                    inventoryNumber: ele.inventoryNumber,
                    directShippingPrice: ele.productCost,
                    ymsWarehouseId: ele.warehouseId,
                  };
                  newList.push(obj);
                });
              });
              if (newList.length > 0) {
                let productGoodsIds = [];
                newList.map((item) => {
                  let productGoodsSpecifications = item.productGoodsSpecifications || [];
                  let specificationsValueList = [];
                  productGoodsSpecifications.map((ele) => {
                    specificationsValueList.push(ele.name + ':' + ele.value);
                  });
                  item.specificationValueId = specificationsValueList.join('_');
                  if (item.productGoodsId) {
                    productGoodsIds.push(item.productGoodsId);
                  }
                });
                let list = v.uniqueFunc(productGoodsIds);
                if (list.length > 0) {
                  (async () => {
                    let newData = await v.getProductInfoByIds(list, newList,
                      false, false, false, api.post_productInfo_queryByProductGoodsIds, 'supplier');
                    v.handleTableData(newData)
                  })();
                }
              }
              v.$forceUpdate();
            }
            v.modifyPriceModal = true;
          }
        });
      });
    },
    // 处理列表数据
    handleTableData(data) {
      if (!data?.length) {
        this.modifyPriceData = data || [];
        return;
      }
      const ymsWarehouseIds = data.map(item => item.warehouseId).filter(Boolean);
      if (!ymsWarehouseIds.length) {
        this.modifyPriceData = data;
        return;
      }
      batchAllWarehouseData(ymsWarehouseIds).then(list => {
        const warehouseMap = {};
        list.forEach(warehouse => {
          let ymsWarehouseDeliverySettings = warehouse.ymsWarehouseDeliverySettings || [];
          let isDeliveryWarehouseTalg = warehouse.isDeliveryWarehouse === 1 && ymsWarehouseDeliverySettings.length > 0;
          warehouse.isDeliveryWarehouseTalg = isDeliveryWarehouseTalg;
          warehouseMap[warehouse.ymsWarehouseId] = warehouse;
        });
        this.modifyPriceData = data.map(item => ({
          ...item,
          isDeliveryWarehouseTalg: warehouseMap[item.warehouseId].isDeliveryWarehouseTalg || false,
          warehouseName: warehouseMap[item.warehouseId].name || ''
        }));
      });
    },
    // 修改价格的确定按钮
    modifyPriceBtn() {
      let v = this;
      let newList = [];
      let keyList = [];
      let hasError = false;
      let valid = true;
      if (v.modifyPriceData.length > 0) {
        let isDeliveryWarehouseTalg = v.modifyPriceData.some((item) => {
          return item.isDeliveryWarehouseTalg === true;
        });
        if (isDeliveryWarehouseTalg) {
          keyList.push('directShippingPrice')
        }
        v.nationalSupplyPriceData.map((item) => {
          let key = `${item.twoCode}_supplyPrice`;
          keyList.push(key);
        });
        for (let key of keyList) {
          if (hasError) {
            break;
          }
          let emptyField = this.modifyPriceData.some((item) => {
            if (key === 'directShippingPrice') {
              return !item[key] && item.isDeliveryWarehouseTalg === true;
            } else {
              return !item[key];
            }
          });
          if (emptyField) {
            this.$Message.error(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007043')}`);
            hasError = true;
            valid = false;
          }
        }
        if (valid) {
          let keyList = [];
          for (let item of v.modifyPriceData) {
            for (let key in item) {
              if (key.indexOf('_supplyPrice') !== -1) {
                keyList.push(key);
              }
            }
          }
          keyList = v.uniqueFunc(keyList);
          let list = this.handerGrouping(v.modifyPriceData, function (item) {
            return [item.specificationValueId];
          }, ['specificationValueId', 'productId', 'productGoodsId', ...keyList], 'goodList');
          list.map((ele) => {
            let productGoodsPrices = [];
            let wmsInventorys = [];
            for (let key in ele) {
              if (key.indexOf('_supplyPrice') !== -1) {
                let countryCode = key.split('_supplyPrice')[0];
                let supplyPrice = ele[key];
                productGoodsPrices.push({
                  countryCode,
                  supplyPrice
                });
              }
            }
            ele.goodList.map((item) => {
              wmsInventorys.push({
                inventoryNumber: item.inventoryNumber,
                productCost: item.isDeliveryWarehouseTalg ? item.directShippingPrice : 0,
                warehouseId: item.warehouseId,
                inventoryId: item.inventoryId
              });
            });
            let obj = {
              productGoodsPrices: productGoodsPrices,
              wmsInventorys: wmsInventorys,
              productId: ele.productId,
              productGoodsId: ele.productGoodsId,
            }
            newList.push(obj);
          });
          if (newList.length > 0) {
            v.axios.put(api.put_productGoods_batchUpdatePrice, newList, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.modifyPriceModal = false;
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
                v.$emit('updateData', true);
              }
            });
          }
        }
      }
    },
    // 处理列表字段
    handleColumns() {
      let v = this;
      v.modifyPriceColumns = [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          minWidth: 350,
          key: 'skuInfo',
          align: 'center',
          render(h, params) {
            let skuImgPath = params.row._productInfo.primaryImage;
            let spuImgPath = params.row._productInfo._spuInfo.primaryImage;
            let imgPath = skuImgPath ? skuImgPath : spuImgPath;
            let sku = params.row.ymsSku;
            let productGoodsSpecifications = params.row._productInfo.productGoodsSpecifications || [];
            ;
            let spec = productGoodsSpecifications.map(i => i.name + '：' + i.value).join('、');
            return h('div', {class: 'flex mt5 mb5'}, [
              v.tableImg(h, params, null, imgPath),
              h('div', {class: 'ml5'}, [
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', {
                    style: {
                      width: '70px',
                      textAlign: 'right'
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000100')),
                  h('p', {
                    style: {
                      flex: 1,
                      textAlign: 'left'
                    }
                  }, params.row._productInfo._spuInfo.name),
                ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', {
                    style: {
                      width: '70px',
                      textAlign: 'right'
                    }
                  }, 'SKU：'),
                  h('p', {
                    style: {
                      flex: 1,
                      textAlign: 'left'
                    }
                  }, sku),
                ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', {
                    style: {
                      width: '70px',
                      textAlign: 'right'
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000240')),
                  h('p', {
                    style: {
                      flex: 1
                    },
                    class: 'color-green'
                  }, spec),
                ]),
              ])
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000241'),
          key: 'warehouseName',
          align: 'center',
          minWidth: 160,
          render(h, params) {
            let {warehouseName, ymsWarehouseName} = params.row;
            let name = warehouseName || ymsWarehouseName;
            return h('span', name)
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000873'),
          renderHeader(h) {
            return h('p', {
              style: {
                whiteSpace: 'nowrap'
              }
            }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000873') + '(' + v.currencyState + ')');
          },
          key: 'directShippingPrice',
          minWidth: 180,
          align: 'center',
          render: (h, params) => {
            let isDeliveryWarehouseTalg = v.modifyPriceData[params.index] ? v.modifyPriceData[params.index].isDeliveryWarehouseTalg : false;
            let value = v.modifyPriceData[params.index].directShippingPrice;
            return h("div", {class: "flex justify-content-center flex-direction align-items-center"},
              isDeliveryWarehouseTalg ? [
                h("InputNumber", {
                  props: {
                    min: 0,
                    max: 9999999,
                    value: value,
                    placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000915'),
                    formatter: function (val) {
                      return formatterNumber(val, 2);
                    }
                  },
                  style: {width: "110px", display: "flex"},
                  class: !value ? "ivu-form-item-error" : "",
                  on: {
                    input: (val) => {
                      v.modifyPriceData[params.index].directShippingPrice = val;
                    }
                  }
                }),
                !value ? h("div", {
                  style: {
                    color: "red",
                    margin: "5px 0",
                    textAlign: "center"
                  }
                }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000873') + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000681')) : ""
              ] : [h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000592'))]
            )
          }
        },
      ];
      let supplyPriceColumns = [];
      return new Promise((resolve) => {
        getAllCountrysData('cn', true).then((countrysList) => {
          getStoreGoodsData(countrysList).then((nationalSupplyPriceData) => {
            v.nationalSupplyPriceData = nationalSupplyPriceData;
            nationalSupplyPriceData.map((item) => {
              let title = item.countryName + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000583') + v.currencyState + "）";
              let key = `${item.twoCode}_supplyPrice`;
              supplyPriceColumns.push({
                title: title,
                key: key,
                minWidth: 220,
                align: 'center',
                render: (h, params) => {
                  let value = v.modifyPriceData[params.index][key];
                  return h("div", {class: "flex justify-content-center flex-direction align-items-center"},
                    [
                      h("InputNumber", {
                        props: {
                          min: 0,
                          max: 9999999,
                          value: value,
                          placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000915'),
                          formatter: function (val) {
                            return formatterNumber(val, 2);
                          }
                        },
                        style: {width: "110px", display: "flex"},
                        class: !value ? "ivu-form-item-error" : "",
                        on: {
                          input: (val) => {
                            let specificationValueId = v.modifyPriceData[params.index].specificationValueId;
                            v.modifyPriceData[params.index][key] = val;
                            v.modifyPriceData.map((ele) => {
                              if (ele.specificationValueId === specificationValueId) {
                                ele[key] = val;
                              }
                            });
                            v.$forceUpdate();
                          }
                        }
                      }),
                      !value ? h("div", {
                        style: {
                          color: "red",
                          margin: "5px 0",
                          textAlign: "center"
                        }
                      }, item.countryName + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000882') + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000681')) : ""
                    ]
                  );
                }
              })
            });
            v.modifyPriceColumns.splice(1, 0, ...supplyPriceColumns);
            resolve(true);
          });
        });
      });
    },
    // 合并单元格
    handleSpan({row, column, rowIndex, columnIndex}) {
      let list = this.modifyPriceColumns.filter((item) => !['warehouseName', 'directShippingPrice'].includes(item.key));
      let colKeys = list.map((item) => item.key);
      let idField = 'specificationValueId';
      return getSpanMethod(this.modifyPriceData, colKeys, idField, row, column, rowIndex, columnIndex)
    },
    // 监听修改价格弹窗
    modifyPriceModalChange(val) {
      if (!val) {
        this.modifyPriceData = [];
      }
    },
  }
}
</script>

<style scoped>

</style>